import { Controller } from '@hotwired/stimulus';
import alertMessage from '../modules/error';

export default class extends Controller {
  static values = {
    studentData: Object,
  };
  static targets = ['link'];

  connect() {
    if (Object.keys(this.studentDataValue).length !== 0) {
      let chartStatus = Chart.getChart('studentChart');
      if (chartStatus != undefined) {
        chartStatus.destroy();
      }

      const links = this.studentDataValue.links;
      const labels = this.studentDataValue.dates.map((date) => [date]);
      const student_mean =
        this.studentDataValue.scores.length > 0
          ? this.studentDataValue.scores.reduce((a, b) => a + b, 0) /
            this.studentDataValue.scores.length
          : 0;

      // Function to get color based on index
      const getBarColor = (index) => {
        const colors = [
          '#FFD93D', // Yellow
          '#6BBFFF', // Light Blue
          '#6FE5A0', // Green
          '#FF8B94', // Light Red
          '#B19CD9', // Purple
          '#FFB18B', // Orange
          '#FF69B4', // Pink
          '#5FD3C4', // Turquoise
        ];
        return colors[index % colors.length];
      };

      // Calculate dynamic bar width based on number of data points
      const dataCount = this.studentDataValue.scores.length;
      const barWidth = 50;

      // Calculate required width for the chart
      const chartWidth = Math.max(600, dataCount * (barWidth + 3));

      // Create wrapper for scrolling
      const canvas = document.getElementById('studentChart');
      const chartContainer = canvas.parentElement;

      // Create scroll wrapper if it doesn't exist
      if (!chartContainer.classList.contains('chart-scroll-wrapper')) {
        chartContainer.style.position = 'relative';
        chartContainer.style.overflow = 'auto';
        chartContainer.classList.add('chart-scroll-wrapper');

        // Create inner container for the chart
        const innerContainer = document.createElement('div');
        innerContainer.style.minWidth = chartWidth + 'px';
        innerContainer.style.height = '100%';
        innerContainer.style.position = 'relative';

        // Move canvas to inner container
        canvas.remove();
        innerContainer.appendChild(canvas);
        chartContainer.appendChild(innerContainer);
      } else {
        // Update width if already exists
        const innerContainer = chartContainer.querySelector('div');
        innerContainer.style.minWidth = chartWidth + 'px';
      }

      let ctx = canvas.getContext('2d');
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Notas',
              data: this.studentDataValue.scores,
              tooltip: this.studentDataValue.exam_names,
              backgroundColor: this.studentDataValue.scores.map((_, index) => getBarColor(index)),
              borderColor: this.studentDataValue.scores.map((_, index) => getBarColor(index)),
              borderWidth: 0,
              borderRadius: 8,
              barThickness: barWidth,
              categoryPercentage: 0.9,
              barPercentage: 0.95,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
              bottom: 20,
              left: 10,
              right: 10,
            },
          },
          hover: {
            intersect: false,
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              titleColor: '#000000',
              bodyColor: '#666666',
              borderColor: '#E5E5E5',
              borderWidth: 1,
              cornerRadius: 8,
              padding: 12,
              displayColors: false,
              callbacks: {
                title: function (context) {
                  let current = context[0];
                  return current.dataset.tooltip[current.dataIndex];
                },
                label: function (context) {
                  return `Nota: ${context.parsed.y.toFixed(1)}`;
                },
              },
            },
            annotation: {
              annotations: {
                averageLine: {
                  type: 'line',
                  yMin: student_mean,
                  yMax: student_mean,
                  borderColor: '#FF6B6B',
                  borderWidth: 2,
                  borderDash: [5, 5],
                  label: {
                    display: true,
                    content: `Média: ${student_mean.toFixed(1)}`,
                    position: 'end',
                    backgroundColor: 'rgba(255, 107, 107, 0.1)',
                    borderColor: '#FF6B6B',
                    borderWidth: 1,
                    borderRadius: 4,
                    color: '#FF6B6B',
                    font: {
                      size: 12,
                      weight: 'bold',
                    },
                    padding: 4,
                  },
                },
              },
            },
          },
          onClick: function (evt, item) {
            if (item.length > 0) {
              window.open(links[item[0].index], '_blank');
            }
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: 10,
              ticks: {
                stepSize: 1,
                font: {
                  size: 12,
                },
              },
              grid: {
                color: '#F0F0F0',
              },
            },
          },
        },
      });
    }
  }

  // TODO: Create a stimulus controller for this method
  copyLinkText() {
    console.log('Texto está sendo clicado!');
    let copyText = this.linkTarget.value;

    navigator.clipboard.writeText(copyText).then(
      () => {
        alertMessage('Link copiado para a área de transferência', 'success');
      },
      () => {
        alertMessage('Erro ao copiar link', 'error');
      },
    );
  }
}
